import {
    GET_ALL_TRANSACTIONS,
    ADD_TRANSACTION,
    EDIT_TRANSACTION,
    DELETE_TRANSACTION
} from '../actions/TransactionActions'

const initialState = {
    data: [],
    totalScans: 0,
    totalPages: 0,
    currentPage: 1,

    latestUpdate: '',
    loading: false,
    error: '',
}

const TransactionReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_TRANSACTION: {
            let tempArray = Object.assign({}, state.allScans)
            tempArray.rows = [action.payload, ...state.allScans.rows]
            return {
                ...state,
                allScans: tempArray,
            }
        }
        case EDIT_TRANSACTION: {
            let tempArray = Object.assign({}, state.allScans)
            let target = tempArray.rows.findIndex(item => {return item.id == action.payload.id})
            tempArray.rows[target] = action.payload            
            return {
                ...state,
                allScans: tempArray,
            }
        }
        case DELETE_TRANSACTION: {
            let tempArray = Object.assign({}, state.allScans)
            let newArray = tempArray.rows.filter(item => {return item.id !== action.payload})
            tempArray.rows = newArray            
            return {
                ...state,
                allScans: tempArray,
            }
        }
        case GET_ALL_TRANSACTIONS: {
            return {
                ...state,
                data: action.payload.transactions.transactions,
                currentPage: action.payload.transactions.currentPage,
                totalScans: action.payload.transactions.totalElements,
                totalPages: action.payload.transactions.totalPages,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default TransactionReducer
